import React from 'react';
import { createRoot } from 'react-dom/client';

import ls from 'local-storage';
import { DndProvider } from 'react-dnd';
import { TouchBackend } from 'react-dnd-touch-backend';
import { Provider } from 'react-redux';
import { animateScroll } from 'react-scroll';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from 'styled-components';

import { ScrollToTopButton } from '../dronebee-ui';
import { login } from './redux/reducers/auth';
import createStore from './redux/store';
import AppRouter from './routers/AppRouter';
import './styles/styles.scss';
import 'focus-visible';
import { GlobalStyles } from './theme/GlobalStyles';
import { FocusVisible } from './theme/FocusVisible';

export const store = createStore();

if (ls('user')) {
  const user = ls('user');
  console.log('User: ', user);
  store.dispatch(login(user));
}

if (ls('authorization')) {
  ls.remove('authorization');
}



const jsx = (
  <Provider store={store}>
    <DndProvider backend={TouchBackend} options={{ enableMouseEvents: true }}>
      <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable
        pauseOnHover />

      <FocusVisible className="js-focus-visible focus-visible">
        <ThemeProvider theme={programConfig.style}>
          <GlobalStyles />
          <AppRouter />
        </ThemeProvider>
      </FocusVisible>

      <ScrollToTopButton handleClick={() => {
        animateScroll.scrollToTop();
      }} />
    </DndProvider>
  </Provider>
);

if (window.Cypress && environment !== 'production') {
  window.store = store;
  window.config = programConfig;
}

const container = document.getElementById('app');
const root = createRoot(container);
root.render(jsx);
